import { ITagAssociationType } from "../../common/models/ITagAssociationType";
import { IeLynxObject } from "../../common/models/eLynxObject";

export enum PollingScheduleEnum {
    NotSelected = -1,
    Unspecified = 0,
    FifteenMinute = 1,
    TenMinute = 2,
    FiveMinute = 3,
    OneMinute = 4,
    ThirtyMinute = 5,
    SixtyMinute = 6,
    SixPerDay = 7,
    FourPerDay = 8,
    OnePerDay = 9,
    NoScheduledPoll = 10,
    TenSecond = 12
}

export interface IPollingScheduleDataModel {
    pollingSchedules: IPollingScheduleObjectModel[];
    tats: ITagAssociationType[];
}
export interface IPollingScheduleObjectModel {
    object: IeLynxObject;
    tagPollingSchedules: ITagPollingScheduleData[];
}

export interface ITagPollingScheduleData {
    object: IeLynxObject;
    tagID: number;
    tagAssociationTypeID: number;
    tagName: string;
    pollingSchedule: PollingScheduleEnum;
    originalPollingSchedule?: PollingScheduleEnum;
}
